import * as React from 'react';
import type { SVGProps } from 'react';

const SvgRectangleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={401} height={107} fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M76.805 96.83H391V13.269L76.805 96.831ZM401 106.832V.261L.298 106.83H401Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRectangleRight;
